import styled from "styled-components";
import { Link } from "react-router-dom";

export const HeaderSection = styled("header")`
  padding: 1rem 0.5rem;

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
`;

export const HorizontalBar = styled.div`
  height: 1px; // Adjust the height as needed
  background-color: #ccc; // Adjust the color as needed
  width: 100%; // Set the width to span the full container width
  margin-top: 0px; // Adjust the top margin as needed
`;
